import {
	dashPrevScrollPosition,
	prevLocationPath,
	roomsPrevScrollPosition,
} from 'src/stores/ui/scroll_position';

import { tick } from 'svelte';
import { get } from 'svelte/store';
import { location } from 'svelte-spa-router';

/**
 * Smoothly scroll the element with the given id into view once the DOM
 * has settled. Generic on purpose so any anchor can reuse it; `block`
 * defaults to `'start'` and can be overridden per call site.
 */
export async function scrollElementIntoView(
	elementId: string,
	block: ScrollLogicalPosition = 'start',
): Promise<void> {
	await tick();
	await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
	document.getElementById(elementId)?.scrollIntoView({ behavior: 'smooth', block });
}

const checkIsInnerRoomPage = (route: string) => {
	return (
		route.includes('home') &&
		route.includes('room') &&
		(route.includes('groups') ||
			route.includes('scenes') ||
			route.includes('thermostats') ||
			route.includes('devices'))
	);
};

export const savePrevScrollPosition = (mainLayoutScrollRef: HTMLDivElement) => {
	if (!mainLayoutScrollRef || get(prevLocationPath) === '') return;

	const route = get(location);
	const isPrevAllRoomsRoute =
		get(prevLocationPath).includes('rooms') && get(prevLocationPath).includes('-1');
	const isPrevDashRoute = get(prevLocationPath).includes('dash');
	const isCurrentRouteInnerRoomPage = checkIsInnerRoomPage(route);

	if (isPrevDashRoute && isCurrentRouteInnerRoomPage) {
		dashPrevScrollPosition.set(mainLayoutScrollRef.scrollTop);
		return;
	}

	if (isPrevAllRoomsRoute && isCurrentRouteInnerRoomPage) {
		roomsPrevScrollPosition.set(mainLayoutScrollRef.scrollTop);
		return;
	}
};

export const setPrevScrollPosition = (mainLayoutScrollRef: HTMLDivElement) => {
	if (!mainLayoutScrollRef) return;

	const route = get(location);
	const prevRoute = get(prevLocationPath);
	const isAllRoomsRoute = route.includes('rooms') && route.includes('-1');
	const isDashRoute = route.includes('dash');
	const isPrevRouteInnerRoomPage = checkIsInnerRoomPage(prevRoute);

	if (isDashRoute && isPrevRouteInnerRoomPage) {
		mainLayoutScrollRef.scrollTop = get(dashPrevScrollPosition);
	} else if (isAllRoomsRoute && isPrevRouteInnerRoomPage) {
		mainLayoutScrollRef.scrollTop = get(roomsPrevScrollPosition);
	} else {
		mainLayoutScrollRef.scrollTop = 0;
	}

	prevLocationPath.set(route);
};

export const resetSavedScrollPosition = (mainLayoutScrollRef: HTMLDivElement) => {
	if (!mainLayoutScrollRef) return;

	roomsPrevScrollPosition.set(0);
	dashPrevScrollPosition.set(0);
	mainLayoutScrollRef.scrollTop = 0;
};
